"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DividerComponent.default;
  }
});

var _DividerComponent = _interopRequireDefault(require("./Divider-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }